import { ImageTransformationEntity } from "~/interfaces/entities/ImageTransformation"
import { createEntitySlice } from "../createEntitySlice"

export const {
  slice: imageTransformations,
  selectors: imageTransformationsSelectors,
} = createEntitySlice<ImageTransformationEntity>("imageTransformations")
